module.exports = __webpack_public_path__ + "static/media/avatar.5fd88976.svg";